module.exports = __webpack_public_path__ + "static/media/LoriGleria.199cd424.png";